import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import type { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { UserManagementListContainer } from './user-management-list/userManagement.container';

/**
 * function UserManagementModule components
 */
export const UserManagementModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.USER_MANAGEMENT_MODULE.FULL_PATH}>
        <Redirect
          to={(APP_ROUTES.USER_MANAGEMENT_MODULE.CHILDREN as RouteConfig).SEARCH.FULL_PATH}
        />
      </Route>
      <Route
        path={(APP_ROUTES.USER_MANAGEMENT_MODULE.CHILDREN as RouteConfig).SEARCH.FULL_PATH}
        component={UserManagementListContainer}
      />
    </>
  );
};
